import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { RfpLabelService } from '../../project-development/tendering/inivitation-to-tender/rfp-labels.service';

@Component({
  selector: 'app-requested-tendering',
  standalone: true,
  imports: [],
  templateUrl: './requested-tendering.component.html',
  styleUrl: './requested-tendering.component.css',
})
export class RequestedTenderingComponent implements OnInit {
  projectId!: string;
  projectName: string;

  isHovering1 = false;
  isHovering2 = false;
  isHovering3 = false;
  isHovering4 = false;
  isHovering5 = false;
  projectIdentifier: string;
  labels: any;
  isRFPorRFQ: string;
  constructor(private router: Router, private activeRoute: ActivatedRoute, private rfpLabelService: RfpLabelService) {}

  ngOnInit(): void {
    // Subscribe to route changes
    this.activeRoute.url.subscribe(() => {
      this.updateRFPorRFQFlag();
      const currentRoute = this.router.url; // Get full URL path
      this.rfpLabelService.updateLabelsFromRoute(currentRoute);
    });
    this.rfpLabelService.labels$.subscribe((labels) => {
      this.labels = labels;
    });
    this.activeRoute.paramMap.subscribe((params) => {
      // NOTE: projectId matches param in routes file
      this.projectId = params.get('projectId');
    });
    this.activeRoute.queryParams.subscribe((params) => {
      this.projectName = params['projectName'];
      this.projectIdentifier = params['projectIdentifier'];
    });
  }

  updateRFPorRFQFlag() {
    const currentRoute = this.router.url.toLowerCase(); // Get full URL path
    if(currentRoute.includes('rfp')){
      this.isRFPorRFQ = 'RFP';
    }else if(currentRoute.includes('rfq')){
      this.isRFPorRFQ = 'RFQ'
    }
    console.log('isRFPorRFQ:', this.isRFPorRFQ);
  }

  navigateToExpression() {
    if (this.projectId) {
      this.router.navigate(['/eoi-requests', this.projectId], {
        queryParams: {
          projectName: this.projectName,
          projectIdentifier: this.projectIdentifier,
        },
      });
    }
  }
  navigateToPQQ() {
    this.router.navigate(['/pqq-requests'], {
      queryParams: {
        projectName: this.projectName,
        projectIdentifier: this.projectIdentifier,
      },
    });
  }
  navigateToRfp() {
    this.router.navigate(['/requests/rfp'], {
      queryParams: {
        projectName: this.projectName,
        projectIdentifier: this.projectIdentifier,
      },
    });
  }
  navigateToRfq() {
    this.router.navigate(['/requests/rfq'], {
      queryParams: {
        projectName: this.projectName,
        projectIdentifier: this.projectIdentifier,
      },
    });
  }
}
